import { render } from "./IconBed.vue?vue&type=template&id=f5ce3590"
import script from "./IconBed.vue?vue&type=script&lang=js"
export * from "./IconBed.vue?vue&type=script&lang=js"
script.render = render

export default script